import React from "react";
import Header from "./Header";

export default function Hero() {
  return (
    <section
      className="relative bg-cover bg-center h-screen min-h-[600px] flex flex-col"
      style={{ backgroundImage: 'url("https://cdn.metabetta.com/assets/metabetta_data_lake.png")' }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black opacity-75 z-10" />

      {/* Header */}
      <div className="relative z-30">
        <Header />
      </div>

      {/* Content */}
      <div className="relative z-20 flex-1 flex flex-col items-center justify-center px-6 text-center">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-white leading-snug max-w-4xl">
          Strategic, data and operational consulting
          <br />
          built from a full-stack technical foundation.
        </h1>
        <a
          href="#contact"
          className="mt-10 sm:mt-16 px-8 py-3 sm:py-4 rounded-full bg-primary-500 text-white font-bold text-sm sm:text-base hover:bg-primary-700 transition shadow-lg"
        >
          Contact Us
        </a>
      </div>
    </section>
  );
}
